import { Temporal } from "@js-temporal/polyfill";
const EASTERN = "America/New_York";
const PACIFIC = "America/Los_Angeles";
const pad = (value: number) => String(value).padStart(2, "0");

export function easternInputToUtc(value: string): string {
	const parts = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/.exec(value);
	if (!parts) throw new Error("Enter MM/DD/YYYY HH:mm:ss in Eastern Time.");
	const [, month, day, year, hour, minute, second] = parts.map(Number);
	try {
		const input = Temporal.PlainDateTime.from({ year, month, day, hour, minute, second }, { overflow: "reject" });
		const zoned = Temporal.ZonedDateTime.from(
			{ timeZone: EASTERN, year, month, day, hour, minute, second },
			{ disambiguation: "earlier", overflow: "reject" }
		);
		if (!zoned.toPlainDateTime().equals(input)) throw new Error("Nonexistent Eastern time");
		return zoned.toInstant().toString();
	} catch {
		throw new Error("Choose a valid Eastern Time outside the daylight-saving clock gap.");
	}
}
export function formatZoned(value: string, zone = EASTERN): string {
	const date = Temporal.Instant.from(value).toZonedDateTimeISO(zone);
	return (
		pad(date.month) +
		"/" +
		pad(date.day) +
		"/" +
		date.year +
		" " +
		pad(date.hour) +
		":" +
		pad(date.minute) +
		":" +
		pad(date.second)
	);
}
export function timeHelper(value: string): string {
	if (!value) return "Enter Eastern Time (24-hour clock).";
	try {
		const utc = easternInputToUtc(value);
		const abbreviation = (zone: string) =>
			new Intl.DateTimeFormat("en-US", {
				timeZone: zone,
				timeZoneName: "short"
			})
				.formatToParts(new Date(utc))
				.find((part) => part.type === "timeZoneName")?.value;
		return (
			"Eastern Time: " +
			formatZoned(utc) +
			" " +
			abbreviation(EASTERN) +
			" · Pacific Time: " +
			formatZoned(utc, PACIFIC) +
			" " +
			abbreviation(PACIFIC)
		);
	} catch {
		return "Enter Eastern Time (MM/DD/YYYY HH:mm:ss).";
	}
}
